import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export function getResponsivePropType(possiblePropTypes) {
  return PropTypes.oneOfType([
    possiblePropTypes,
    PropTypes.shape({
      xl: possiblePropTypes,
      l: possiblePropTypes,
      m: possiblePropTypes,
      s: possiblePropTypes,
      xs: possiblePropTypes,
    }),
  ]);
}



// WEBPACK FOOTER //
// ./src/utils/propTypes.js